// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface KeyProviderHeaderProps {
  keyProviders: unknown[];
  filterKeyProvider?: string;
  handleFilterKeyProvider: (e: unknown) => void;
}

function KeyProviderHeader({
  keyProviders,
  filterKeyProvider,
  handleFilterKeyProvider,
}: KeyProviderHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="bulk-grid-game-name-th">
      <span className="mb-2">{t('Key provider')}</span>
      <select
        className="form-control "
        value={filterKeyProvider || ''}
        onChange={handleFilterKeyProvider}
      >
        <option value="">{t('All')}</option>
        {keyProviders
          ? [...keyProviders]
            ?.sort((a: any, b: any) => a.name.localeCompare(b.name))
            .map((x: any) => (
              <option key={x.id} value={x.id}>
                {x.name}
              </option>
            ))
          : ''}
      </select>
    </div>
  );
}

export default KeyProviderHeader;
